import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { ShoppingCart, Car, Bike, Filter, Plus, Check, Gift } from 'lucide-react';

const PRODUCTS = [
  { id: 'p1', name: 'Shampoing Auto Plus', description: 'Shampooing Le Hub qui nettoie en profondeur, démoustique et dégraisse. Mousse stable, rinçage facile, séchage sans traces.', category: 'nettoyage', price: 8.99, stock: 50, image_url: 'https://static.prod-images.emergentagent.com/jobs/a141aa61-045e-433f-ae65-8a8ddb299488/images/040e74ab1b1e3b010069ee81901ada8abbfd1a958ba06c46947ee28fdd9baee0.png', vehicle_type: 'auto' },
  { id: 'p2', name: 'Lustreur Express', description: 'Spray lustreur Le Hub qui élimine taches et salissures, offre un brillant protecteur longue durée. Sans rinçage.', category: 'protection', price: 12.99, stock: 30, image_url: 'https://static.prod-images.emergentagent.com/jobs/a141aa61-045e-433f-ae65-8a8ddb299488/images/badf6531e7d5c49971bad65a956651a4d1ebfc31f5486739afd8135143d43c69.png', vehicle_type: 'auto' },
  { id: 'p3', name: 'Cire Protection', description: 'Cire Le Hub avec effet polish qui prolonge l\'éclat et préserve la peinture. Pellicule anticorrosive et chasse-pluie.', category: 'protection', price: 14.99, stock: 25, image_url: 'https://static.prod-images.emergentagent.com/jobs/a141aa61-045e-433f-ae65-8a8ddb299488/images/f9027f6ba43c4f5fad8a528ad2337d1c74c94ab98c4ddbf52a6af8181acd265f.png', vehicle_type: 'auto' },
  { id: 'p4', name: 'Nettoyant Intérieur', description: 'Nettoyant Le Hub pour sellerie et plastiques intérieurs. Formule douce et efficace.', category: 'nettoyage', price: 9.99, stock: 40, image_url: 'https://static.prod-images.emergentagent.com/jobs/a141aa61-045e-433f-ae65-8a8ddb299488/images/dee3b7efde914c929ed9ae44545c5407b68fc89f5eaa62d16f55e54e8ec7b9b3.png', vehicle_type: 'auto' },
  { id: 'p5', name: 'Shampoing Brillance 500ml', description: 'Shampooing Le Hub haute brillance pour un résultat professionnel. Concentré et économique.', category: 'nettoyage', price: 6.50, stock: 60, image_url: 'https://static.prod-images.emergentagent.com/jobs/a141aa61-045e-433f-ae65-8a8ddb299488/images/cc5277176b904b3d74d3db6a1cf3fd74d56e22356ffda2f5c9d4f4ba610059a1.png', vehicle_type: 'auto' },
  { id: 'p6', name: 'Kit Lavage Moto', description: 'Kit complet Le Hub pour moto: shampooing, lustrant, cire et microfibre. Coffret premium.', category: 'nettoyage', price: 29.99, stock: 20, image_url: 'https://static.prod-images.emergentagent.com/jobs/a141aa61-045e-433f-ae65-8a8ddb299488/images/c63fa2857061e96ae4050452f4d44062f546df0c88ee10bb9eb3a61f443034ba.png', vehicle_type: 'moto' },
  // Produits dérivés Le Hub
  { id: 'g1', name: 'Casquette Le Hub', description: 'Casquette noire brodée avec le logo Le Hub Atelier Auto Moto en rouge. Snapback ajustable, qualité premium.', category: 'goodies', price: 24.99, stock: 100, image_url: 'https://static.prod-images.emergentagent.com/jobs/83a2641e-b7ab-41ca-ae72-cc388d3b119a/images/7bcf0bdc034c5b02b16e5ddc2c37e5e14350d50b098615bbdf50245cd7c3135d.png', vehicle_type: 'all' },
  { id: 'g2', name: 'T-Shirt Le Hub', description: 'T-shirt noir 100% coton avec logo Le Hub Atelier Auto Moto imprimé en rouge. Coupe moderne et confortable.', category: 'goodies', price: 29.99, stock: 150, image_url: 'https://static.prod-images.emergentagent.com/jobs/83a2641e-b7ab-41ca-ae72-cc388d3b119a/images/bd5a7733bac81b4989b828b66ba1837f615d88f1e8e7d645fab92eb8771364df.png', vehicle_type: 'all' },
  { id: 'g3', name: 'Porte-Clés Le Hub', description: 'Porte-clés métallique chromé avec logo Le Hub. Design élégant style clé de voiture avec attache cuir.', category: 'goodies', price: 14.99, stock: 200, image_url: 'https://static.prod-images.emergentagent.com/jobs/83a2641e-b7ab-41ca-ae72-cc388d3b119a/images/02deb6ae3af6ca151aed48dd3690e122cb156bc12587a231dfedd61fa3c8924a.png', vehicle_type: 'all' },
  { id: 'g4', name: 'Mug Le Hub', description: 'Mug en céramique noire avec logo Le Hub Atelier Auto Moto. Parfait pour votre café du matin. 350ml.', category: 'goodies', price: 12.99, stock: 120, image_url: 'https://static.prod-images.emergentagent.com/jobs/83a2641e-b7ab-41ca-ae72-cc388d3b119a/images/009ce194a6c9c11eda088bc2fd5019cc78172abfb29f7dc3ee8429641a57501f.png', vehicle_type: 'all' },
];

const categories = [
  { id: 'all', name: 'Tous' },
  { id: 'nettoyage', name: 'Nettoyage' },
  { id: 'protection', name: 'Protection' },
  { id: 'mecanique', name: 'Mécanique' },
  { id: 'goodies', name: 'Goodies Le Hub' },
];

export default function ShopPage() {
  const { user, token } = useAuth();
  const { addToCart, cartItems, openCart } = useCart();
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('all');
  const [vehicleFilter, setVehicleFilter] = useState('all');
  const [addedProducts, setAddedProducts] = useState({});

  const filteredProducts = PRODUCTS.filter(p => {
    if (activeCategory !== 'all' && p.category !== activeCategory) return false;
    if (vehicleFilter !== 'all' && p.vehicle_type !== vehicleFilter && p.vehicle_type !== 'all') return false;
    return true;
  });

  const handleAddToCart = (product) => {
    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      image: product.image_url
    });
    setAddedProducts(prev => ({ ...prev, [product.id]: true }));
    toast.success(`${product.name} ajouté au panier`);
    
    // Reset the added state after 2 seconds
    setTimeout(() => {
      setAddedProducts(prev => ({ ...prev, [product.id]: false }));
    }, 2000);
  };

  const isInCart = (productId) => {
    return cartItems.some(item => item.id === productId);
  };

  const handleBuy = async (product) => {
    if (!user) {
      toast.error('Veuillez vous connecter pour acheter');
      navigate('/connexion');
      return;
    }
    
    addToCart(product);
    navigate('/checkout');
  };

  return (
    <div className="min-h-screen bg-[#09090B]">
      {/* Hero */}
      <section className="bg-gradient-to-b from-zinc-900 to-[#09090B] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-4">
            <ShoppingCart className="text-red-500" size={40} />
            <h1 className="text-5xl font-bold text-white">
              NOTRE <span className="text-red-500">BOUTIQUE</span>
            </h1>
          </div>
          <p className="text-xl text-zinc-400">
            Produits d'entretien et accessoires pour votre véhicule
          </p>
        </div>
      </section>

      {/* Filters */}
      <section className="border-b border-zinc-800 sticky top-20 z-30 bg-[#09090B]/95 backdrop-blur">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center gap-4 py-4">
            <div className="flex items-center gap-2 text-zinc-400">
              <Filter size={18} />
              <span>Filtres:</span>
            </div>
            
            {/* Category Filter */}
            <div className="flex gap-2">
              {categories.map((cat) => (
                <Button
                  key={cat.id}
                  variant={activeCategory === cat.id ? 'default' : 'ghost'}
                  size="sm"
                  onClick={() => setActiveCategory(cat.id)}
                  className={activeCategory === cat.id ? 'bg-red-600' : 'text-zinc-400'}
                  data-testid={`shop-filter-${cat.id}`}
                >
                  {cat.name}
                </Button>
              ))}
            </div>

            <div className="h-6 w-px bg-zinc-700" />

            {/* Vehicle Filter */}
            <div className="flex gap-2">
              <Button
                variant={vehicleFilter === 'all' ? 'default' : 'ghost'}
                size="sm"
                onClick={() => setVehicleFilter('all')}
                className={vehicleFilter === 'all' ? 'bg-zinc-700' : 'text-zinc-400'}
              >
                Tous
              </Button>
              <Button
                variant={vehicleFilter === 'auto' ? 'default' : 'ghost'}
                size="sm"
                onClick={() => setVehicleFilter('auto')}
                className={vehicleFilter === 'auto' ? 'bg-zinc-700' : 'text-zinc-400'}
              >
                <Car size={16} className="mr-1" /> Auto
              </Button>
              <Button
                variant={vehicleFilter === 'moto' ? 'default' : 'ghost'}
                size="sm"
                onClick={() => setVehicleFilter('moto')}
                className={vehicleFilter === 'moto' ? 'bg-zinc-700' : 'text-zinc-400'}
              >
                <Bike size={16} className="mr-1" /> Moto
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredProducts.map((product, idx) => (
              <Card 
                key={product.id}
                className={`bg-zinc-900/50 overflow-hidden card-hover group animate-fade-in ${
                  product.badge ? 'border-red-500/50 shadow-lg shadow-red-900/20' : 'border-zinc-800'
                }`}
                style={{ animationDelay: `${idx * 0.05}s` }}
                data-testid={`product-card-${product.id}`}
              >
                <div className={`relative overflow-hidden bg-zinc-800 ${product.badge ? 'h-96' : 'h-48'}`}>
                  <img 
                    src={product.image_url} 
                    alt={product.name}
                    className={`w-full h-full object-cover ${product.badge ? 'object-top' : ''} group-hover:scale-110 transition-transform duration-500`}
                  />
                  {product.badge && (
                    <div className="absolute top-3 left-3">
                      <Badge className="bg-red-600 text-white border-0 px-3 py-1 text-xs font-bold animate-pulse">
                        <Gift size={12} className="mr-1" />
                        {product.badge}
                      </Badge>
                    </div>
                  )}
                  <div className="absolute top-3 right-3">
                    <Badge variant="outline" className="border-zinc-600 bg-black/50 text-white">
                      {product.vehicle_type === 'auto' ? <Car size={12} className="mr-1" /> : product.vehicle_type === 'moto' ? <Bike size={12} className="mr-1" /> : null}
                      {product.vehicle_type}
                    </Badge>
                  </div>
                </div>
                <CardContent className="p-5">
                  <Badge className="bg-zinc-800 text-zinc-300 mb-3">{product.category}</Badge>
                  <h3 className="text-lg font-bold text-white mb-2">{product.name}</h3>
                  <p className="text-zinc-400 text-sm mb-4 line-clamp-2">{product.description}</p>
                  
                  <div className="flex items-center justify-between">
                    <div>
                      {product.original_price && product.original_price > product.price ? (
                        <div className="flex items-baseline gap-2">
                          <p className="text-2xl font-bold text-red-500">{product.price.toFixed(2)}€</p>
                          <p className="text-sm text-zinc-500 line-through">{product.original_price.toFixed(2)}€</p>
                        </div>
                      ) : (
                        <p className="text-2xl font-bold text-red-500">{product.price.toFixed(2)}€</p>
                      )}
                      <p className="text-xs text-zinc-500">
                        {product.original_price && product.original_price > product.price
                          ? `Economie ${(product.original_price - product.price).toFixed(2)}€`
                          : `${product.stock} en stock`}
                      </p>
                    </div>
                    <Button 
                      className={`${addedProducts[product.id] || isInCart(product.id) ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'}`}
                      onClick={() => handleAddToCart(product)}
                      data-testid={`add-cart-${product.id}`}
                    >
                      {addedProducts[product.id] ? (
                        <>
                          <Check size={16} className="mr-2" />
                          Ajouté
                        </>
                      ) : (
                        <>
                          <Plus size={16} className="mr-2" />
                          Ajouter
                        </>
                      )}
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="text-center py-12">
              <ShoppingCart className="mx-auto text-zinc-600 mb-4" size={48} />
              <p className="text-zinc-500">Aucun produit trouvé avec ces filtres</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
